// lib/shared/isValidLink.ts
var e = [
	"http:",
	"https:",
	"tel:",
	"mailto:"
];
function t(t) {
	let n = t.trim();
	if (n === "") return "";
	try {
		let t = new URL(n);
		return e.includes(t.protocol) ? n : "";
	} catch {
		return n;
	}
}
function n(n, r = !1) {
	if (typeof n != "string") return !1;
	let i = t(n);
	if (i === "") return !1;
	try {
		let t = new URL(i);
		return e.includes(t.protocol);
	} catch {
		if (r) return !1;
	}
	try {
		let t = new URL(i, document.location.origin);
		return t.origin === document.location.origin && e.includes(t.protocol);
	} catch {
		return !1;
	}
}
export { n as isValidLink, t as sanitizeLink };
